import { gql } from '@apollo/client';
const RENAME_SPECIFICATION_FOLDER = gql `
  mutation RenameSpecificationFolder($modelSpecificationFolderId: ID!, $name: String!) {
    updateModelSpecificationFolder(
      modelSpecificationFolderId: $modelSpecificationFolderId
      name: $name
    ) {
      modelSpecificationFolder {
        id
        name
        modelSpecificationsCount
        foldersCount
        canBeRemoved
      }
    }
  }
`;
export default RENAME_SPECIFICATION_FOLDER;
